import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import curriculumImg from "../../Assest/Images/curriculum.svg";
import PrekSection from "./motion";
import PrekSectionRight from "./motionright";
import MunMazhalai from "../../Assest/Images/munmazhai.png";
import Mazhalai from "../../Assest/Images/mazhai.png";
import NilaiOndru from "../../Assest/Images/nizhalondru.png";
import NilaiIrandu from "../../Assest/Images/nizhalirandu.png";
import NilaiMoondru from "../../Assest/Images/nizhalmoondru.png";

import NilaiNaangu from "../../Assest/Images/nizhalnangu.png";

import NilaiIyndhu from "../../Assest/Images/nizhaliyndu.png";
import NilaiAaru from "../../Assest/Images/nizhalyezhu1.jpg";
import NilaiYezhu from "../../Assest/Images/nizhalyettu1.jpg";
import NilaiYettu from "../../Assest/Images/nizhalyettu.png";

const prekSections = [
  {
    type: "left",
    title: "Mun Mazhalai",
    image: MunMazhalai,
    content:
      "Introduction to 50 basic Tamil words through songs and stories, covering numbers, colors, animals, fruits, vegetables, and body parts.",
    index: 0,
  },
  {
    type: "right",
    title: "Mazhalai",
    image: Mazhalai,
    content:
      "Introduction to Tamil letters (Uyir, Ayudha, Mei) and numbers 1–10, with basic vocabulary on fruits, vegetables, animals, body parts, and colors, including writing practice",
    index: 1,
  },
  {
    type: "left",
    title: "Nilai 1",
    image: NilaiOndru,
    content:
      "Learning to recognize and write Uyir, Ayudha, Mei, and Uyirmei letters, with practice in reading and conversing using simple words.",
    index: 2,
  },
  {
    type: "right",
    title: "Nilai 2",
    image: NilaiIrandu,
    content:
      "Learning to recognize, read, write, and speak simple words and series-based Uyirmei letters.",
    index: 3,
  },
  {
    type: "left",
    title: "Nilai 3",
    image: NilaiMoondru,
    content:
      "Developing comprehension through reading short sentences and stories, with clear pronunciation, discussion skills, and learning Tamil equivalents for English words",
    index: 4,
  },
  {
    type: "right",
    title: "Nilai 4",
    image: NilaiNaangu,
    content:
      "Reading and understanding short sentences and stories, with clear pronunciation, discussion skills, Tamil vocabulary building, and an introduction to basic grammar",
    index: 5,
  },
  {
    type: "left",
    title: "Nilai 5",
    image: NilaiIyndhu,
    content:
      "Reading and understanding short sentences and stories, with clear pronunciation, discussion skills, Tamil vocabulary building, and an introduction to basic grammar",
    index: 6,
  },
  {
    type: "right",
    title: "Nilai 6",
    image: NilaiAaru,
    content:
      "Clear and accurate reading, comprehension, writing, translation, comparative grammar with English, conversational Tamil, and development of skills in essay, letter writing, and story continuation.",
    index: 7,
  },
  {
    type: "left",
    title: "Nilai 7",
    image: NilaiYezhu,
    content:
      "Building accurate reading, comprehension, and writing skills with comparative grammar, conversation, essay and letter writing, and story completion exercises",
    index: 6,
  },
  {
    type: "right",
    title: "Nilai 8",
    image: NilaiYettu,
    content:
      "Advancing clear reading, comprehension-based writing, Tamil–English translation and comparison, deep interpretation of dialogues, and extended practice in essays, letters, and story continuation.",
    index: 7,
  },
];

function Curriculum() {
  const isMobile = useMediaQuery("(max-width:600px)");

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: isMobile ? "1.5rem" : "4rem 6rem",
      backgroundColor: "#F7F3FC",
      textAlign: isMobile ? "center" : "left",
    },
    textContainer: {
      textAlign: isMobile ? "center" : "left",
      padding: isMobile ? "0 1rem" : "0",
    },
    heading: {
      fontSize: isMobile ? "28px" : "48px",
      fontWeight: "bold",
      color: "#000000",
      marginBottom: "12px",
    },
    subText: {
      fontSize: isMobile ? "14px" : "18px",
      color: "#808080",
      lineHeight: "1.6",
      maxWidth: isMobile ? "100%" : "600px",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: isMobile ? "80%" : "100%",
      maxWidth: "450px",
    },
  };

  return (
    <>
      {/* Curriculum Section */}
      <Box sx={styles.container}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6} sx={styles.textContainer}>
            <Typography sx={styles.heading}>Curriculum</Typography>
            <Typography sx={styles.subText}>
              Our curriculum is designed to provide comprehensive learning
              experiences that foster creativity, critical thinking, and
              practical knowledge. With a perfect blend of theoretical concepts
              and hands-on training, our programs prepare students for
              real-world challenges.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} sx={styles.imageContainer}>
            <img
              src={curriculumImg}
              alt="Curriculum Illustration"
              style={styles.image}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Pre-K Sections (Limited to 5) */}
      {prekSections
        .slice(0, 10)
        .map((section, i) =>
          section.type === "left" ? (
            <PrekSection
              key={i}
              title={section.title}
              content={section.content}
              index={section.index}
              image={section.image}
            />
          ) : (
            <PrekSectionRight
              key={i}
              titleRight={section.title}
              contentRight={section.content}
              index={section.index}
              image={section.image}
            />
          )
        )}
    </>
  );
}

export default Curriculum;
